export function getRequirement(name, requirements) {
    for (const requirement of requirements) {
        if (requirement.key === name) {
            return requirement;
        }
    }
}

export function hasRequirement(name, requirements) {
    return !!getRequirement(name, requirements);
}
